import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import AppState from '@webapp/store/state';

import styled from 'styled-components';

import Typography from '@components/basics/typography';
import StepButton from '@webapp/components/actions/step-button';
import { TracPage } from '@services/tracpage/types/trac-page';
import { UpdateTracPage } from '../../../store/tracpage/action-creators';
import { CallHistoryMethodAction, push } from 'connected-react-router';
import { SetArtistPreview } from '@webapp/store/tracpage/action-creators';
import { Translate } from 'react-localize-redux';

interface ArtistSiteEditorContainerProps {
  className?: string;
  children: React.ReactNode;
  title: React.ReactNode;
  page: TracPage;
  path?: string;
  publish: (page: TracPage) => UpdateTracPage<TracPage>;
  anotherTab: (tab: string) => CallHistoryMethodAction;
  openPreview: any;
  isMobile?: boolean;
}

const mapStateToProps = (state: AppState) => ({
  page: state.tracpage.artistPage,
  isMobile: state.ui.mobile,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  openPreview: () => dispatch(new SetArtistPreview(true)),
  anotherTab: (tab: string) => dispatch(push(`/artist/page/${tab}`)),
  publish: (page: TracPage) => dispatch(new UpdateTracPage('tracpage', page)),
});

export const ArtistSiteEditorContainer: React.FC<ArtistSiteEditorContainerProps> = (
  props
) => {
  const { publish } = props;
  return (
    <div className={props.className}>
      <Typography className="mb-40 artist-title" type="subheader" weight="400">
        {props.title}
      </Typography>
      {props?.isMobile ? (
        <SubNav>
          <div className="left-nav">
            <span
              onClick={() => props.anotherTab('settings')}
              className={`${props.path === 'settings' ? 'active' : ''}`}
            >
              <Translate id="ARTIST_SITE.SIDEBAR.SETTINGS" />
            </span>
            <span
              onClick={() => props.anotherTab('home')}
              className={`${props.path === 'home' ? 'active' : ''}`}
            >
              <Translate id="ARTIST_SITE.SIDEBAR.HOME" />
            </span>
            <span
              onClick={() => props.anotherTab('merch')}
              className={`${props.path === 'merch' ? 'active' : ''}`}
            >
              <Translate id="ARTIST_SITE.SIDEBAR.MERCH" />
            </span>
          </div>
          <div>
            <span onClick={() => props.openPreview()}>Preview</span>
          </div>
        </SubNav>
      ) : null}
      {props.children}

      <StepButton
        isValid={true}
        onNext={() => publish(props.page)}
        label="Save & Publish"
        disableLoader={true}
      />
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(ArtistSiteEditorContainer)`
  .artist-title {
    margin-left: 1rem;
  }
  margin-bottom: 100px;
  @media ${({ theme }) => theme.device.laptopS} {
    margin-bottom: 0;
  }
`);

const SubNav = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 1rem 2.5rem 1rem;
  font-size: 16px;
  font-weight: 700;
  .left-nav {
    display: flex;
    gap: 0.8rem;
    font-size: 16px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.secondaryDark};
    .active {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;
